class Subscription {
  constructor() {
    this.openModalCity = false;

    this.currentCity = null;

    this.cities = null;

    this.isSeparatePage = false;
  }

  start() {
    const chooseCity = document.querySelector('#subscription-block #choose-city');
    const { isConvertingPageview } = kudago;
    chooseCity.addEventListener('click', this.handlerModalCity);
    const button = document.querySelector('#subscription-block button');
    button.addEventListener('click', this.onSubscribe.bind(this));
    this.currentCity = this.getCurrentCity();
    if ((this.currentCity === null || isConvertingPageview) && !this.isSeparatePage) {
      document.querySelector('#subscription-block').remove();
      return;
    }
    this.cities = document.querySelectorAll('#subscription-block .modal-city-choose div');
    this.cities.forEach((item) => {
      if (item.id === this.currentCity) {
        item.classList.add('active-city');
      } else {
        item.classList.remove('active-city');
      }
    });
    this.cities.forEach((item) => {
      item.addEventListener('click', this.onChangeCity.bind(this));
    });
    this.showCurrentCity();
    [document.querySelector('#email_editors_choice')].forEach((element) => {
      element.checked = true;
    });
    const checkboxesItems = document.querySelectorAll('#subscription-block .checkbox-confirmation input[type=checkbox]');
    checkboxesItems.forEach((checkbox) => checkbox.addEventListener('change', this.onCheckBoxChange));
  }

  handlerModalCity(e) {
    e.preventDefault();
    const chooseCityModal = document.querySelector('#subscription-block .modal-city-choose');
    if (!this.openModalCity) {
      this.openModalCity = true;
      chooseCityModal.style.display = 'flex';
    } else {
      this.openModalCity = false;
      chooseCityModal.style.display = 'none';
    }
  }

  onSubscribe() {
    const data = {
      enabled_notifications: [],
      email: '',
      location: this.currentCity,
    };

    const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

    const checkboxesItems = document.querySelectorAll('#subscription-block input[type=checkbox] + label');
    checkboxesItems.forEach((item) => {
      item.classList.remove('error-checkbox');
    });

    const errorBlock = document.querySelector('#subscription-block #subscription-status-error');
    errorBlock.textContent = '';

    const mailInput = document.querySelector('#subscription-block input[type=text]');
    mailInput.classList.remove('error');

    const notificationsCheckboxes = document.querySelectorAll('#subscription-block .checkbox-notification input[type=checkbox]');
    notificationsCheckboxes.forEach((item) => {
      if (item.checked) {
        data.enabled_notifications.push(item.name);
      }
    });
    if (data.enabled_notifications.length === 0) {
      errorBlock.textContent = 'Пожалуйста, укажите типы рассылки, на которые вы хотите подписаться';
      // eslint-disable-next-line no-shadow
      const checkboxes = document.querySelectorAll('#subscription-block .checkbox-notification input[type=checkbox] + label');
      checkboxes.forEach((item) => {
        item.classList.add('error-checkbox');
      });
      return;
    }
    data.email = mailInput.value.trim();
    if (data.email === '') {
      errorBlock.textContent = '';
      mailInput.classList.add('error');
      return;
    }
    if (!EMAIL_REGEXP.test(data.email)) {
      errorBlock.textContent = 'Пожалуйста, укажите корректный адрес электронной почты';
      mailInput.classList.add('error');
      return;
    }

    const fetchPromise = fetch('/api/subscriptions/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(data),
    });

    fetchPromise.then((response) => {
      if (response.ok) {
        this.resetForm();
        const modalEl = document.getElementById('subscription-modal');
        modalEl.style.display = 'flex';
      } else {
        response.json().then((res) => {
          if (res.location) {
            errorBlock.textContent = 'Пожалуйста выберите город';
            mailInput.classList.add('error');
            return;
          }
          if (res.email) {
            errorBlock.textContent = res.email[0] || 'Домен почты не входит в список разрешенных ';
            mailInput.classList.add('error');
            return;
          }
          errorBlock.textContent = 'Что-то пошло не так, проверьте данные формы или попробуйте позднее';
          mailInput.classList.add('error');
        }).catch(() => {
          errorBlock.textContent = 'Что-то пошло не так, проверьте данные формы или попробуйте позднее';
          mailInput.classList.add('error');
        });
      }
    });
  }

  resetForm() {
    const checkboxesItems = document.querySelectorAll('#subscription-block input[type=checkbox]');
    checkboxesItems.forEach((item) => {
      item.checked = false;
    });
    const mailInput = document.querySelector('#subscription-block input[type=text]');
    mailInput.value = '';
  }

  getCurrentCity() {
    const urlSplit = document.location.pathname.split('/');
    if (urlSplit.indexOf('mailer') !== -1) {
      this.isSeparatePage = true;
    }
    const currentCity = kudago.location;
    if (currentCity === 'spb' || currentCity === 'msk') {
      return currentCity;
    }
    return null;
  }

  onChangeCity(e) {
    e.preventDefault();
    this.currentCity = e.currentTarget.id;
    this.cities.forEach((item) => {
      if (item.id === this.currentCity) {
        item.classList.add('active-city');
      } else {
        item.classList.remove('active-city');
      }
    });
    this.showCurrentCity();
  }

  showCurrentCity() {
    const { currentCity } = this;
    const citySpan = document.querySelector('#current-city');
    let city = 'городе';

    switch (currentCity) {
      case 'msk':
        city = 'Москве';
        break;
      case 'spb':
        city = 'Санкт-Петербурге';
        break;
    }
    if (citySpan) {
      citySpan.innerText = city;
    }
  }

  onCheckBoxChange() {
    const selectedCheckboxes = [];
    const checkboxesItems = document.querySelectorAll('#subscription-block .checkbox-confirmation input[type=checkbox]');
    checkboxesItems.forEach((item) => {
      if (item.checked) {
        selectedCheckboxes.push(item);
      }
    });
    const button = document.querySelector('#subscription-block button');
    button.disabled = selectedCheckboxes.length !== checkboxesItems.length;
  }
}

module.exports = Subscription;
